import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

interface OfflineImagesProps {
    projectId: string;
    isOffline: boolean;
}

export default function OfflineImages({ projectId, isOffline }: OfflineImagesProps) {
    const defineState = useSelector((state: RootState) => state.define);
    const effectiveProjectId = projectId || defineState.projectId;

    return (
        <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-bold mb-6">Project Images</h2>

            <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-6">
                <p className="font-bold">Placeholder Component</p>
                <p>This is a placeholder for the Project Images component.</p>
                <p>Project ID: {effectiveProjectId}</p>
            </div>

            <div className="grid grid-cols-1 gap-4">
                <div className="bg-gray-100 p-4 rounded">
                    <h3 className="font-semibold mb-2">Image Upload</h3>
                    <p className="text-sm text-gray-600">
                        In the full implementation, this section would allow users to upload images related to the project.
                    </p>
                    <div className="mt-4 p-8 border-2 border-dashed border-gray-300 rounded flex flex-col items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-gray-400 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <p className="text-gray-500">Drag and drop images here, or click to select files</p>
                    </div>
                </div>

                <div className="bg-gray-100 p-4 rounded">
                    <h3 className="font-semibold mb-2">Image Gallery</h3>
                    <p className="text-sm text-gray-600">
                        In the full implementation, this section would display a gallery of uploaded images.
                    </p>
                    <div className="mt-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="bg-gray-200 aspect-square rounded flex items-center justify-center">
                                <span className="text-gray-500">Image {i}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
} 